import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiChannelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_channel"}/>
}
